import React from 'react';

import { makeStyles, Theme } from '@material-ui/core';
import { Star, StarBorder } from '@material-ui/icons';
import { TranslateFunction } from 'react-localize-redux';

import { DashboardCard } from '@fd/ui/atoms';

const useStyles = makeStyles((theme: Theme) => ({
  starsContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
  },
  star: {
    color: '#9caed4',
    width: '49px',
    height: '49px',
    marginRight: theme.spacing(1),
  },
}));

export type AppDownloadsCardProps = {
  isLoading: boolean;
  rating?: number;
  translate: TranslateFunction;
};

export const AppRatingCard = (props: AppDownloadsCardProps) => {
  const { isLoading, rating = 0, translate } = props;
  const classes = useStyles();

  const renderStars = () => {
    const stars = [] as any;
    for (let i = 0; i < 5; i++) {
      if (i < rating) {
        stars.push(
          <Star key={`filled-star-${i}`} data-fd={`filled-star-${i}`} className={classes.star} />
        );
      } else {
        stars.push(
          <StarBorder
            key={`empty-star-${i}`}
            data-fd={`empty-star-${i}`}
            className={classes.star}
          />
        );
      }
    }
    return stars;
  };
  return (
    <DashboardCard isLoading={isLoading} title={translate('Current_rating') as string}>
      <div
        role="img"
        aria-label={translate('App_rating_ariaLabel', { rating: rating }) as string}
        className={classes.starsContainer}
      >
        {renderStars()}
      </div>
    </DashboardCard>
  );
};
